import { Box, styled } from "@mui/material";
import { StyledForm } from "../form/Form.styled";

export const StyledQuoteItemForm = styled('form')(({ theme }) => ({
  width: "60rem",
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
  ".row": {
    display: "flex",
    gap: "1rem",
    width: "100%",
    ".column": {
      display: "flex",
      flexDirection: "column",
      gap: "1rem",
      alignItems: "center",
      justifyContent: "center",
      flex: "1",
      h4: {
        width: "100%",
      },
      ".MuiInputBase-root": {
        width: "100%",
        minHeight: "4rem",
      },
      p: {
        color: theme.color.main,
      },
      ".select": {
        minWidth: "40rem",
      },
      ".textArea": {
        minWidth: "40rem"
      },
    },
  },
  ".materialList": {
    width: "100%",
    height: "20rem",
    overflowY:"scroll",
    ".header": {color: theme.color.background,
      background: theme.color.main,},
    ".materials": {
      display: "flex",
      padding: ".5rem 1rem",
      
      ".pos": {
        width: "10%",
    },
    ".material": {
        width: "50%",
    },
    ".pricepiece": {
        width: "15%",
    },
    ".amount": {
        width: "10%",
    },
    ".total": {
        width: "10%",
    },
    ".actions": {
      width: "5%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "svg:hover": {
        color: theme.color.main
      }
    }
    },
  }
}));
